import * as _ from "lodash";
var SimpleCache = /** @class */ (function () {
    function SimpleCache(getter, cmp) {
        var _this = this;
        this.getter = getter;
        this.cmp = cmp;
        this.data = [];
        this.getArray = function () {
            return _this.data;
        };
        this.get = function (key) {
            var idx = _this.findPromise(key);
            if (idx >= 0) {
                if (_this.data[idx].data)
                    return new Promise(function (res) { return res(_this.data[idx].data); });
                else {
                    var w_1 = _this.data[idx].waiters;
                    return new Promise(function (res, rej) { return w_1.push({ res: res, rej: rej }); });
                }
            }
            else {
                _this.data.push({
                    key: key,
                    waiters: [],
                });
                return new Promise(function (res, rej) {
                    var p = _this.getter(key);
                    p.then(function (data) {
                        var i = _this.findPromise(key);
                        if (i >= 0) {
                            _this.data[i].data = data;
                            res(data);
                            _this.resolveAll(i, data);
                        }
                        else {
                            rej("somthing strange went wrong oO");
                        }
                    }, function (err) {
                        var i = _this.findPromise(key);
                        if (i >= 0) {
                            rej(err);
                            _this.rejectAll(i, err);
                        }
                        else {
                            rej("somthing strange went wrong oO");
                        }
                    });
                });
            }
        };
        this.findPromise = function (key) {
            var idx = _.findIndex(_this.data, function (d) {
                if (_this.cmp)
                    return _this.cmp(key, d.key);
                else
                    return key === d.key;
            });
            return idx;
        };
        this.resolveAll = function (idx, data) {
            if (idx >= 0) {
                var w = _this.data[idx].waiters;
                _.forEach(w, function (ww) { return ww.res(data); });
            }
        };
        this.rejectAll = function (idx, error) {
            if (idx >= 0) {
                var w = _this.data[idx].waiters;
                _.forEach(w, function (ww) { return ww.rej(error); });
            }
        };
    }
    return SimpleCache;
}());
export default SimpleCache;
//# sourceMappingURL=SimpleCache.js.map